import request from '../../untils/request'

export function getLesseeArrearsList() {
    return request({
        url: '/bigScreen/getLesseeArrearsList',
        method: 'get',
    })
}

export function getDeviceRunState() {
  return request({
      url: '/bigScreen/getDeviceRunState',
      method: 'get',
  })
}

export function getEnergyUsageStatistics() {
  return request({
      url: '/bigScreen/getEnergyUsageStatistics',
      method: 'get',
  })
}

export function getEnergyLossRank(param) {
  return request({
      url: '/bigScreen/getEnergyLossRank',
    method: 'get',
    params: param
  })
}

